"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CycleCountReport = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const cycle_count_report_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/cycle-count-report/components/cycle-count-report-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
require("./cycle-count-report.less");
let CycleCountReport = class CycleCountReport extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Cycle_Count_Report.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator(a, b) {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                }
            },
            columnDefs: [
                {
                    headerName: "Cycle Count Id",
                    field: "Cycle Count Id",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Pharmacy Name",
                    field: "Pharmacy Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Med Name",
                    field: "Strength Description",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Exception Reason",
                    field: "Exception Reason",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Action",
                    field: "Action",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Blind Count",
                    field: "Blind Count",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Actual Count",
                    field: "Actual Count",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Qty Difference",
                    field: "Qty Difference",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "User",
                    field: "User Full Name",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Date",
                    field: "Date",
                    filter: "agDateColumnFilter",
                    filterParams: {
                        comparator: (filterLocalDateAtMidnight, cellValue) => {
                            const dateAsString = cellValue;
                            if (dateAsString === null)
                                return -1;
                            const dateParts = dateAsString.split("/");
                            const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                            if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                                return 0;
                            }
                            if (cellDate < filterLocalDateAtMidnight) {
                                return -1;
                            }
                            if (cellDate > filterLocalDateAtMidnight) {
                                return 1;
                            }
                        },
                        browserDatePicker: true
                    }
                }
            ],
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadCycleCount();
    }
    componentWillUnmount() {
        store_1.reportsStore.cycleCountData = null;
    }
    render() {
        const storeData = store_1.reportsStore.cycleCountData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(cycle_count_report_header_1.CycleCountReportHeader, { title: "Cycle Count Report", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(cycle_count_report_header_1.CycleCountReportHeader, { title: "Cycle Count Report", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(cycle_count_report_header_1.CycleCountReportHeader, { title: "Cycle Count Report", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
CycleCountReport = __decorate([
    mobx_react_1.observer
], CycleCountReport);
exports.CycleCountReport = CycleCountReport;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/cycle-count-report/cycle-count-report.tsx
// module id = 3892
// module chunks = 0